import { apiSlice } from "./Api/apiSlice";

export const quizzesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizzes: builder.query({
      query: () => "/quizzes",
    }),
  }),
});

export const { useGetQuizzesQuery } = quizzesApi;
